import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles.css';
var rootDiv = document.createElement("div");
rootDiv.id = "root";
document.body.appendChild(rootDiv);
ReactDOM.render(React.createElement(React.StrictMode, null,
    React.createElement(App, null)), document.getElementById('root'));
